import { useState } from 'react';
import { submitWireTransfer } from '../../services/invoiceService';
import { showToast } from '../../utils/Toast';

const useWireTransfer = () => {
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const resetWireTransferState = () => {
    setSuccess(false);
    setError(null);
  };

  const submitWirePayment = async (data) => {
    setLoading(true);
    setError(null);
    setSuccess(false);

    try {
      // console.log("Submitting wire transfer with data:", data.referenceId);

      if (!data.referenceId) {
        throw new Error("Reference ID is required");
      }

      const formData = new FormData();
      formData.append('referenceId', data.referenceId);

      if (data.depositAmount) {
        formData.append('depositAmount', data.depositAmount);
      }

      if (data.paymentProof) {
        formData.append('paymentProof', data.paymentProof);
      }

      const response = await submitWireTransfer(formData);
      // console.log("Wire transfer response:", response);

      setSuccess(true);
      showToast('Reference Id Saved Successfully!', 'success');
      return response;
    } catch (err) {
      setSuccess(false);
      // console.error("Wire transfer submission error:", err);

      let errorMsg = 'Failed to submit wire transfer';
      if (err.response?.data?.message) {
        errorMsg = err.response.data.message;
      } else if (err.request) {
        errorMsg = 'No response from server';
      } else if (err.message) {
        errorMsg = err.message;
      }

      setError(errorMsg);
      showToast(errorMsg, 'error');
    } finally {
      setLoading(false);
    }
  };

  return {
    success,
    loading,
    error,
    submitWirePayment,
    resetWireTransferState
  };
};

export default useWireTransfer;
